import React from 'react';
import { useTranslation } from 'react-i18next';
import { Layout } from 'fronton-react';
import { HeaderSection, OtherSection, RootLayout } from 'common/components';
import { KAZAKHSTAN } from 'common/constants/region-codes';
import { useRegionIdSelector } from 'modules/model-json';
import { PromoBlock } from 'remotes/promo-block';
import { SpecialOffer } from 'remotes/special-offer';
import {
  StorageAdditionalSection,
  StorageDesignCard,
  StorageDesignPanel,
  StorageDesignSection,
  StorageGallerySection,
  StorageSpaceoBanner,
  StorageStylesSection,
} from './components';
import {
  STORAGE_CDN_PATH,
  STORAGE_ELEMENT_BLOCK,
  STORAGE_LANDING_NAME,
  STORAGE_PATH,
} from './storage-constants';

/**
 * Вью лендинга Спасео Куб
 */
export const Storage = () => {
  const regionId = useRegionIdSelector();
  const isRuRegion = regionId !== KAZAKHSTAN;
  const { t } = useTranslation();

  return (
    <RootLayout currentPage={STORAGE_PATH}>
      <HeaderSection
        imgList={[
          {
            ldSrcSet: `${STORAGE_CDN_PATH}/header/1-ld.jpg/1-ld.jpg`,
            dSrcSet: `${STORAGE_CDN_PATH}/header/1-d.jpg/1-d.jpg`,
            tSrcSet: `${STORAGE_CDN_PATH}/header/1-t.jpg/1-t.jpg`,
            mSrcSet: `${STORAGE_CDN_PATH}/header/1-m.jpg/1-m.jpg`,
            alt: t('header.img-alt-1'),
          },
          {
            ldSrcSet: `${STORAGE_CDN_PATH}/header/2-ld.jpg/2-ld.jpg`,
            dSrcSet: `${STORAGE_CDN_PATH}/header/2-d.jpg/2-d.jpg`,
            tSrcSet: `${STORAGE_CDN_PATH}/header/2-t.jpg/2-t.jpg`,
            mSrcSet: `${STORAGE_CDN_PATH}/header/2-m.jpg/2-m.jpg`,
            alt: t('header.img-alt-2'),
          },
          {
            ldSrcSet: `${STORAGE_CDN_PATH}/header/3-ld.jpg/3-ld.jpg`,
            dSrcSet: `${STORAGE_CDN_PATH}/header/3-d.jpg/3-d.jpg`,
            tSrcSet: `${STORAGE_CDN_PATH}/header/3-t.jpg/3-t.jpg`,
            mSrcSet: `${STORAGE_CDN_PATH}/header/3-m.jpg/3-m.jpg`,
            alt: t('header.img-alt-3'),
          },
        ]}
        bgColor="#87978a"
        description={t('header.description')}
        mediaType="carousel"
        title={t('header.title')}
      />
      <StorageDesignPanel isRuRegion={isRuRegion} regionId={regionId} />
      <Layout>
        <PromoBlock elementBlock={STORAGE_ELEMENT_BLOCK} />
        <SpecialOffer elementBlock={STORAGE_ELEMENT_BLOCK} />
        <StorageDesignSection isRuRegion={isRuRegion} regionId={regionId} />
        <StorageGallerySection regionId={regionId} />
      </Layout>
      <StorageStylesSection />
      <Layout>
        <StorageDesignCard isRuRegion={isRuRegion} regionId={regionId} />
        {isRuRegion && <StorageSpaceoBanner />}
        <StorageAdditionalSection />
      </Layout>
      <OtherSection
        elementBlock={`${STORAGE_ELEMENT_BLOCK} / other`}
        landingName={STORAGE_LANDING_NAME}
        promotionName={`${STORAGE_ELEMENT_BLOCK}_bottom`}
      />
    </RootLayout>
  );
};
